module.exports = __webpack_public_path__ + "static/media/progress-gift-day.736fc6b8.png";